import React, { Fragment, useState } from 'react';
import { trim } from 'lodash';
import { Appearance, Button } from '@src/components/Button';
import { TextField } from '@src/components/TextField';
import { trackEvent } from '@src/metrics';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { CandidateProfileActionsModalProps } from './props';
import './styles.scss';

export const ACTIONS_MODAL_CLASS_NAME = 'candidate-profile-actions-modal';

export const CandidateProfileActionsModal: React.FC<CandidateProfileActionsModalProps> = ({
  applicationId,
  closeModal,
  defaultInputMessage,
  onChatClosed,
  openingId,
  sendMessage,
  threadId,
}) => {
  const [message, setMessage] = useState(defaultInputMessage || '');

  const confirm = (): void => {
    closeModal();

    onChatClosed();

    if (trim(message)) {
      sendMessage(message);
    }

    trackEvent({
      context: MetricContext.END_CHAT,
      interaction: MetricAction.END_CHAT,
      payload: {
        'Application Id': applicationId,
        'Opening Id': openingId,
        'Thread Id': threadId,
        'Type': 'Close',
      },
    });
  };

  return (
    <Fragment>
      <h4>Close chat</h4>

      <Fragment>
        <p>Send a closing message to the user.</p>

        <TextField
          defaultValue={message}
          fullWidth
          multiline
          onBlur={() =>
            trackEvent({
              context: MetricContext.END_CHAT,
              interaction: MetricAction.SET_END_CHAT_MESSAGE,
              payload: {
                'Application Id': applicationId,
                'Opening Id': openingId,
                'Thread Id': threadId,
                'Type': 'Close',
              },
            })
          }
          onChange={message => setMessage(message)}
          wrapperClassName={`${ACTIONS_MODAL_CLASS_NAME}__textarea`}
        />
      </Fragment>

      <div className={`${ACTIONS_MODAL_CLASS_NAME}__buttons`}>
        <Button isDisabled={!message.length} onClick={confirm}>
          Confirm
        </Button>

        <Button
          appearance={Appearance.SECONDARY}
          className={`${ACTIONS_MODAL_CLASS_NAME}__button-cancel`}
          onClick={closeModal}
        >
          Cancel
        </Button>
      </div>
    </Fragment>
  );
};
